import API from "@/utils/axiosApi/powderedMilkApi.js";
import {
  BuiedPointClick_Fn,
  Exposurer_special_Fn
} from "@/assets/js/BuriedPointEvent";

export default {
  name: "",
  data() {
    return {
      info: [
        {
          name: "母乳喂养",
          id: "",
          img: require("../../../../../assets/images/powderedMilk/feed.png")
        },
        {
          name: "宝宝奶粉",
          id: "",
          img: require("../../../../../assets/images/powderedMilk/babymilk.png")
        },
        {
          name: "孕产奶粉",
          id: "",
          img: require("../../../../../assets/images/powderedMilk/pregnant.png")
        },
        {
          name: "成人奶粉",
          id: "",
          img: require("../../../../../assets/images/powderedMilk/adultmilk.png")
        }
      ]
    };
  },
  methods: {
    Tolist(parentId, name) {
      const babyBuried = JSON.parse(localStorage.getItem("babyBuried"));
      BuiedPointClick_Fn("milkinfo_home_topic_click", {
        Baby_Month: babyBuried ? babyBuried.name : "",
        topic_name: name
      });
      this.$router.push({
        name: "milkArticleLists",
        query: {
          // 头部title，
          previousTitle: name,
          // 区分奶粉星球和专题
          previousStatus: "selection",
          // 第一级标签
          parentId: parentId,
          planetTag: 0
        }
      });
    }
  },
  computed: {
    babyBuried() {
      const babyBuried = JSON.parse(localStorage.getItem("babyBuried"));
      return babyBuried ? babyBuried : {};
    }
  },
  created() {},
  mounted() {
    Exposurer_special_Fn.observe(
      "milkinfo_home_topic_expo",
      ".history_",
      false,
      {
        Baby_Month: this.babyBuried.name
      }
    );
    let obj = {
      tagId: 0, //父级id 0：全部
      module: 0, //模块id 0:奶粉百科
      tagType: 0 // 标签类型 0：专题 1：星球
    };
    API.getTagAll(obj, res => {
      if (res.code == 200) {
        this.info.forEach(item => {
          res.data.forEach(val => {
            console.log(val.parentName, item.name, val.parentName == item.name);
            if (val.parentName == item.name) {
              item.parentId = val.parentId;
            }
          });
        });
      }
    });
  }
};
